import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const router = new VueRouter({
    mode: 'history',
    routes: [
        {
            path: '/', 
            component: () => import('./page/index.vue'),
            meta: {
            },
        },
        {
            path: '/index', 
            component: () => import('./page/index.vue'),
            meta: {
            },
        },
        {
			path: '/list',
			component: () => import('./page/list.vue'),
            meta: {
                isKeep: true,
                showTabbar: true,
            },
		},
        {
			path: '/timecapsule',
			component: () => import('./page/timecapsule.vue'),
            meta: {
                isKeep: true,
                showTabbar: true,
            },
		},
        {
            path: '/certificateList', 
            component: () => import('./page/dynamicCondition.vue'),
        },
        {
            path: '/dynamic', 
            component: () => import('./page/dynamicCondition.vue'),
            meta: {
                showTabbar: true,
            },
        },
        {
            path: '/dyDetail', 
            component: () => import('./page/dynamicDetail.vue'),
            meta: {
            },
        },
        {
            path: '/look', 
            component: () => import('./page/look.vue'),
        },
        {
            path: '/toHelp', 
            component: () => import('./page/toHelp.vue'),
        },
        {
            path: '/shixianxinyuan', 
            component: () => import('./page/shixianxinyuan.vue'),
        },
        {
            path: '/pay', 
            component: () => import('./page/pay.vue'),
        },
        {
            path: '/groupBooking', 
            component: () => import('./page/groupBooking.vue'),
        },
        {
            path: '/invitationPoster', 
            component: () => import('./page/invitationPoster.vue'),
        },
        {
            path: '/payafter', 
            component: () => import('./page/payafter.vue'),
        },
        {
            path: '/claimList', 
            component: () => import('./page/claimList.vue'),
            meta: {
                showTabbar: true,
            },
        },
        {
            path: '/claimList2', 
            component: () => import('./page/claimList.vue'),
        },
        {
            path: '/suixinjuan', 
            component: () => import('./page/suixinjuan.vue'),
        },
        {
            path: '/remark', 
            component: () => import('./page/remark.vue'),
        },
        {
            path: '/bangdan', 
            component: () => import('./page/bangdan.vue'),
        },
        {
            path: '/detail', 
            component: () => import('./page/detail.vue'),
        },
        {
            path: '/wangqi', 
            component: () => import('./page/wangqi.vue'),
        },
        {
            path: '/cerDetail', 
            component: () => import('./page/cerDetail.vue'),
        },
        {
            path: '/blogin', 
            component: () => import('./page/blogin.vue'),
            meta: {
                fullScreen: true,
            },
        },
        {
            path: '/login', 
            component: () => import('./page/login.vue'),
            meta: {
                fullScreen: true,
            },
        },
        {
            path: '/childXinyuan', 
            component: () => import('./page/childXinyuan.vue'),
        },
        {
            path: '/childOption', 
            component: () => import('./page/childOption.vue'),
        },
        {
            path: '/activity', 
            component: () => import('./page/activity.vue'),
        },
        {
            path: '/activityFeedback', 
            component: () => import('./page/activiFeedback'),
        },
    ]
})

export default router;